<template>
  <div class="main">
    <div class="top">
      <div class="navbar">
        <div class="left" @click="goBack">
          <img src="@/assets/groupRob/back.png" alt="" class="back" />
          <!-- <img src="@/assets/groupRob/logo.png" alt="" class="logo" /> -->
        </div>
        <div class="title">
          <div class="switch">
            <div class="item" :class="{ active: $route.path == '/grouprob/a' }" @click="$router.replace('/grouprob/a')">
              进行中
            </div>
            <div class="item" :class="{ active: $route.path.startsWith('/grouprob/b') }" @click="$router.replace('/grouprob/b')">
              已报名
            </div>
          </div>
        </div>
        <div class="right" @click="moreVisible = true">更多</div>
      </div>
    </div>
    <router-view />
    <Popup v-model="popupVisible" :html="desc" :title="desc_title" @close="popupClose" />
    <More v-model="moreVisible" />
    <Shadow v-if="isShare" />
    <grounp-footer :path="['/grouprob/a','/grouprob/b']"></grounp-footer>
  </div>
</template>

<script>
  import Popup from "./popup.vue";
  import More from "./more.vue";
  import Shadow from "./shadow.vue";
  import mixin from "./mixin";
  import grounpFooter from './components/footer.vue'

  export default {
    components: {
      Popup,
      More,
      Shadow,
      grounpFooter
    },
    mixins: [mixin],
    data () {
      return {
        desc_title: "活动规则",
        desc: null,
        popupVisible: false,
        moreVisible: false,
        isShare: true,
      };
    },
    created () {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token)
      }
      const { type, share } = this.$route.query;
      this.type = type || 1;
      this.isShare = share || false;
      this.getDesc();
      this.popupVisible = !share && !localStorage.getItem("__group_rob_rule_popup__");
    },
    methods: {
      popupClose () {
        localStorage.setItem("__group_rob_rule_popup__", true);
      },
      goBack () {
        this.params("", "", "goBack");
      },
      getDesc () {
        this.$api
          .get("cms-v2/index/agreement/app/detail", { number: "pmsgz" })
          .then((res) => {
            this.desc_title = res.title;
            this.desc = res.content;
          });
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    box-sizing: border-box;
  }

  .main {
    height: 100%;
    overflow: hidden;
    background: #eeeeee;
    font-size: 1.4rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .top {
      .navbar {
        background: url(~@/assets/groupRob/top-bg.png);
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: top;
        height: calc(4.4rem + var(--status-height));
        display: flex;
        align-items: stretch;
        padding: var(--status-height) 1.2rem 0;

        .left,
        .right {
          flex: 0 0 8rem;
          max-width: 8rem;
          display: flex;
          align-items: center;
          color: #fff;

          .back {
            flex: 0 0 2.1rem;
            height: 2.1rem;
          }

          .logo {
            flex: 0 0 6.2rem;
            height: 2rem;
            margin-left: 0.4rem;
          }
        }

        .right {
          justify-content: flex-end;
        }

        .title {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          .switch {
            display: flex;
            align-items: stretch;
            padding: 0.1rem;
            width: 16rem;
            height: 3.2rem;
            border-radius: 1.5rem;
            border: 0.1rem solid rgba(255, 255, 255, 0.5);
            background: rgba(0, 0, 0, 0.2);

            .item {
              flex: 1;
              font-weight: 700;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;

              &.active {
                background: #fff;
                border-radius: 1.4rem;
                color: #ff1515;
              }
            }
          }
        }
      }
    }
  }
</style>